/* ============================================================
   WOW Graphics — Product page (PDP) interactions
   Gallery switch + zoom · quantity stepper · option pills →
   line-item properties · terms gate · AJAX add-to-cart + toast.
   ============================================================ */
(function () {
  "use strict";
  function ready(fn) { if (document.readyState !== "loading") fn(); else document.addEventListener("DOMContentLoaded", fn); }

  ready(function () {
    var root = document.querySelector("[data-pdp]");

    function updateCount(n) {
      var dot = document.querySelector(".cart-dot");
      if (dot) { dot.textContent = n; dot.style.display = n > 0 ? "" : "none"; }
    }
    function toast(label) {
      var t = document.querySelector(".toast.pdp-toast");
      if (!t) { t = document.createElement("div"); t.className = "toast pdp-toast"; document.body.appendChild(t); }
      var ic = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>';
      t.innerHTML = '<span class="toast-ic">' + ic + '</span><div><strong>Added to cart</strong><span>' + label + "</span></div>";
      requestAnimationFrame(function () { t.classList.add("show"); });
      clearTimeout(t._h); t._h = setTimeout(function () { t.classList.remove("show"); }, 3800);
    }

    // ----- Complete Your Kit upsells (work even without the PDP root) -----
    document.querySelectorAll("[data-upsell-add]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var id = btn.dataset.upsellAdd;
        if (!id || !window.fetch || btn.classList.contains("on")) return;
        fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json", "Accept": "application/json" }, body: JSON.stringify({ id: id, quantity: 1 }) })
          .then(function (r) { if (!r.ok) throw new Error(); return r.json(); })
          .then(function () { return fetch("/cart.js").then(function (r) { return r.json(); }); })
          .then(function (cart) {
            updateCount(cart.item_count);
            btn.classList.add("on");
            var card = btn.closest(".gfx-upsell"); if (card) card.classList.add("on");
            btn.innerHTML = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg> ADDED';
            toast(btn.dataset.upsellTitle || "Add-on");
          })
          .catch(function () {});
      });
    });

    if (!root) return;

    // ----- Gallery -----
    var main = root.querySelector(".gal-main");
    var imgs = main ? Array.prototype.slice.call(main.querySelectorAll("img")) : [];
    var thumbs = Array.prototype.slice.call(root.querySelectorAll(".gal-thumb"));
    thumbs.forEach(function (t, i) {
      t.addEventListener("click", function () {
        thumbs.forEach(function (x) { x.classList.remove("on"); });
        imgs.forEach(function (x) { x.classList.remove("on"); });
        t.classList.add("on");
        if (imgs[i]) imgs[i].classList.add("on");
      });
    });
    if (main) {
      main.addEventListener("mouseenter", function () { main.classList.add("zoom"); });
      main.addEventListener("mouseleave", function () { main.classList.remove("zoom"); });
    }

    // ----- Option pills → hidden line-item-property inputs -----
    root.querySelectorAll("[data-pill-group]").forEach(function (group) {
      var hidden = group.querySelector("input[type=hidden]");
      group.querySelectorAll(".gfx-pill").forEach(function (btn) {
        btn.addEventListener("click", function () {
          group.querySelectorAll(".gfx-pill").forEach(function (b) { b.classList.remove("on"); });
          btn.classList.add("on");
          if (hidden) hidden.value = btn.dataset.value || btn.textContent.trim();
        });
      });
    });

    // ----- Variant options → hidden id + live price -----
    // Pill groups whose label matches a real product option select the
    // matching variant; groups that don't stay pure line-item properties.
    (function () {
      var dataEl = root.querySelector("[data-variant-data]");
      var idInput = root.querySelector("input[name=id]");
      var priceEl = root.querySelector(".cfg-price");
      if (!dataEl || !idInput) return;
      var vd; try { vd = JSON.parse(dataEl.textContent); } catch (e) { return; }
      if (!vd || !vd.variants || vd.variants.length < 2) return;
      var norm = function (s) { return (s || "").trim().toLowerCase(); };
      var groups = {};
      root.querySelectorAll("[data-pill-group]").forEach(function (g) {
        vd.options.forEach(function (name, i) {
          if (norm(name) === norm(g.dataset.label)) groups[i] = g;
        });
      });
      var idxs = Object.keys(groups);
      if (!idxs.length) return;
      function currentVariant() {
        for (var i = 0; i < vd.variants.length; i++) {
          if (String(vd.variants[i].id) === String(idInput.value)) return vd.variants[i];
        }
        return vd.variants[0];
      }
      function apply() {
        var sel = currentVariant().options.slice();
        idxs.forEach(function (i) {
          var on = groups[i].querySelector(".gfx-pill.on");
          if (on) sel[i] = on.dataset.value || on.textContent.trim();
        });
        for (var k = 0; k < vd.variants.length; k++) {
          var match = true;
          for (var j = 0; j < sel.length; j++) {
            if (norm(vd.variants[k].options[j]) !== norm(sel[j])) { match = false; break; }
          }
          if (match) {
            idInput.value = vd.variants[k].id;
            if (priceEl) priceEl.textContent = vd.variants[k].price;
            return;
          }
        }
      }
      // sync pill highlight to the initially selected variant, then take over
      idxs.forEach(function (i) {
        var val = norm(currentVariant().options[i]);
        groups[i].querySelectorAll(".gfx-pill").forEach(function (b) {
          b.classList.toggle("on", norm(b.dataset.value || b.textContent) === val);
          b.addEventListener("click", apply);
        });
      });
      apply();
    })();

    // ----- Quantity stepper -----
    var qtyInput = root.querySelector("input[name=quantity]");
    var qtyVal = root.querySelector("[data-qty-val]");
    root.querySelectorAll("[data-qty]").forEach(function (b) {
      b.addEventListener("click", function () {
        var cur = parseInt(qtyInput.value, 10) || 1;
        var next = b.dataset.qty === "inc" ? cur + 1 : cur - 1;
        next = Math.max(1, Math.min(20, next));
        qtyInput.value = next;
        if (qtyVal) qtyVal.textContent = next;
      });
    });

    // ----- Terms gate -----
    var terms = root.querySelector("[data-terms]");
    var addBtn = root.querySelector(".add-btn");
    function syncTerms() { if (addBtn && terms) addBtn.disabled = !terms.checked; }
    if (terms) { terms.addEventListener("change", syncTerms); syncTerms(); }

    // ----- AJAX add to cart -----
    var form = root.querySelector('form[action*="/cart/add"]');
    if (form) {
      form.addEventListener("submit", function (e) {
        if (addBtn && addBtn.disabled) { e.preventDefault(); return; }
        if (!window.fetch) return; // native submit fallback
        e.preventDefault();
        var fd = new FormData(form);
        if (addBtn) addBtn.disabled = true;
        fetch("/cart/add.js", { method: "POST", body: fd, headers: { "Accept": "application/json" } })
          .then(function (r) { if (!r.ok) throw new Error("add failed"); return r.json(); })
          .then(function () { return fetch("/cart.js").then(function (r) { return r.json(); }); })
          .then(function (cart) { updateCount(cart.item_count); toast(root.dataset.title || "Item"); syncTerms(); })
          .catch(function () { form.submit(); });
      });
    }
  });
})();
